import { gsap } from '../global/gsap';

const initFollowCursor = (followEl, container) => {
    let mouseX = 0;
    let mouseY = 0;

    let xTo = gsap.quickTo(followEl, 'x', { duration: 0.4, ease: 'power3' });
    let yTo = gsap.quickTo(followEl, 'y', { duration: 0.4, ease: 'power3' });

    gsap.set(followEl, {
        opacity: 0,
        scale: 0,
    });

    container.addEventListener('mouseenter', () => {
        gsap.to(followEl, {
            opacity: 1,
            scale: 1
        });
    });

    container.addEventListener('mouseleave', () => {
        gsap.to(followEl, {
            opacity: 0,
            scale: 0
        });
    });

    container.addEventListener('mousemove', (e) => {
        const rect = container.getBoundingClientRect();
        mouseX = e.clientX - rect.left;
        mouseY = e.clientY - rect.top;

        xTo(mouseX);
        yTo(mouseY);
    });
};

export default initFollowCursor;
